import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { filterActive: Boolean }
  static targets = ["filterToggleButton"]
  static outlets = ["property-manager"]

  toggleFilter(event) {
    event?.preventDefault()
    if (this.hasPropertyManagerOutlet) {
      this.propertyManagerOutlet.toggleFilter(event)
    }
  }

  refreshFilterButton() {
    if (!this.hasFilterToggleButtonTarget) return

    const button = this.filterToggleButtonTarget
    const icon = button.querySelector("i")

    if (icon) {
      icon.className = this.filterActiveValue ? "bi bi-funnel-fill" : "bi bi-funnel"
    }
  }
}
